import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className, isEngravingFacet }) {
    return (
        <label className={`ns-checkbox ns-d-block ns-color-black ns-mr-1 ${className}`} tabIndex="0">
            {isEngravingFacet && value === "1" ? "Yes" : isEngravingFacet && value !== "1" ? "No" : value}
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark" onClick={(e) => e.stopPropagation()}/>
        </label>
    )
}